export default class Main extends React.Component{
	constructor(props) {
		super(props);
	}
	
	render(){
		const {background='#D8D8D8',fontSize='12px',color='#333',width='20px',height='20px',value='1'} = this.props;
		const _style = {
			background:background,
			fontSize:fontSize,
			color:color,
			width:width,
			height:height,
			borderRadius:'50%',
			textAlign:'center',
			lineHeight:height,
			display:'inline-block',
			marginRight:'18px'
		};
		return (
			<span style={_style}>
				{value}
			</span>
		)
	}
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/public/wf-circle-icon/index.js